/**
 * @description Enum containing routes to all pages rendered by react-router
 */
export enum AdminRoutes {
  Login = "/",
  Home = "/home",
  ResetPassword = "/reset",
  ResetPasswordRequest = "/reset-request",
  AccountRecovery = "/find-account",
  FindAccountGuide = "/guides/find-account",
  ResetPasswordGuide = "/guides/reset-password",
  LoginCodeGuide = "/guides/login-code",
  SetPassword = "/verify",
  Mfa = "/mfa",
  LoginCode = "/login-code",
  AuthCallback = "/auth/callback",
  AndroidPrivacy = "/android/privacy",
  User = "/users",
  UserDetail = "/user/:userId",
  UserEdit = "/user/:userId/edit",
  SitesList = "/sites",
  SiteCreate = "/site/create",
  SiteEdit = "/site/:siteId/edit/",
  OrganizationList = "/organizations",
  OrganizationCreate = "/organization/create",
  OrganizationDetail = "/organization/:organizationId",
  OrganizationDetailView = "/organization/:organizationId/detail",
  OrganizationEdit = "/organization/:organizationId/edit",
  OrganizationProgramList = "/organization/:organizationId/programs/",
  OrganizationWellnessResourcesList = "/organization/:organizationId/wellness-resources/",
  OrganizationWellnessResourcesDetail = "/organization/:organizationId/wellness-resource/:id",
  OrganizationYearlyCurriculum = "/organization/:organizationId/yearly-curriculum/",
  OrganizationYearlyCurriculumCreate = "/organization/:organizationId/yearly-curriculum/create/",
  OrganizationYearlyCurriculumDetail = "/organization/:organizationId/yearly-curriculum/:academicYearId",
  OrganizationYearlyCurriculumTemplate = "/organization/:organizationId/yearly-curriculum/template/:academicYearId",
  OrganizationYearlyCurriculumEdit = "/organization/:organizationId/yearly-curriculum/:id/edit/",
  OrganizationRequirementsEPAList = "/organization/:organizationId/epas",
  OrganizationRequirementsEPACreate = "/organization/:organizationId/epa/create",
  OrganizationRequirementsEPAEdit = "/organization/:organizationId/epa/:requirementId/edit",
  OrganizationRequirementsEPAView = "/organization/:organizationId/epa/:requirementId",
  OrganizationRequirementsCompetencyList = "/organization/:organizationId/competencies",
  OrganizationRequirementsCompetencyCreate = "/organization/:organizationId/competency/create",
  OrganizationRequirementsCompetencyEdit = "/organization/:organizationId/competency/:requirementId/edit",
  OrganizationRequirementsCompetencyView = "/organization/:organizationId/competency/:requirementId",
  OrganizationDomainsList = "/organization/:organizationId/domains",
  OrganizationRequirementsITERList = "/organization/:organizationId/iters",
  OrganizationRequirementsITERCreate = "/organization/:organizationId/iter/create",
  OrganizationRequirementsITEREdit = "/organization/:organizationId/iter/:requirementId/edit",
  OrganizationRequirementsITERView = "/organization/:organizationId/iter/:requirementId",
  OrganizationAnalytics = "/organization/:organizationId/analytics",
  Metrics = "/metrics",
  HospitalCompetition = "/hospital-competition",
  EducationRecordAccessLog = "/education-record-access-log",
  OrganizationFeedbackList = "/organization/:organizationId/feedbacks",
  OrganizationAllFeedbackForUser = "/organization/:organizationId/all-feedback/:userId",
  OrganizationFeedbackDetail = "/organization/:organizationId/feedback/:feedbackId",
  OrganizationLearners = "/organization/:organizationId/learners",
  OrganizationLearnerDetail = "/organization/:organizationId/learner/:userId",
  OrganizationMentors = "/organization/:organizationId/mentors",
  OrganizationMentorDetail = "/organization/:organizationId/mentor/:userId",

  GraduationClassList = "/organization/:organizationId/graduation-class",
  GraduationClassCreate = "/organization/:organizationId/graduation-class/create",
  GraduationClassView = "/organization/:organizationId/graduation-class/:graduationClassId",
  GraduationClassEdit = "/organization/:organizationId/graduation-class/:graduationClassId/edit",
  GraduationClassUploadUsers = "/organization/:organizationId/graduation-class/:graduationClassId/upload-csv-users",

  TagsList = "/tags",
  BadgesList = "/badges",
  VetStore = "/vet-store",
  BadgeCreate = "/badge/create",
  BadgeEdit = "/badge/:badgeId/edit",
  ResourcesList = "/resources",
  ResourcesDetail = "/resource/:resourceId",
  WellnessResourcesList = "/wellness-resources",
  WellnessResourcesView = "/wellness-resource/view/:id",
  EPAList = "/epas",
  EPACreate = "/epa/create",
  EPADetail = "/epa/:requirementId",
  EPAEdit = "/epa/:requirementId/edit",
  CompetenciesList = "/competencies",
  CompetenciesCreate = "/competency/create",
  CompetenciesDetail = "/competency/:requirementId",
  CompetenciesEdit = "/competency/:requirementId/edit",
  DomainsList = "/domains",
  ITERsList = "/iters",
  ITERsCreate = "/iter/create",
  ITERsDetail = "/iter/:requirementId",
  ITERsEdit = "/iter/:requirementId/edit",
  SpeciesList = "/species",
  AcademicYearList = "/academic-year",
  AcademicYearCreate = "/academic-year/create",
  AcademicYearEdit = "/academic-year/edit/:id",
  AcademicYearDetail = "/academic-year/:academicYearId",

  UploadCSVUsers = "/upload-csv-users",
  UploadCSVPrograms = "/upload-csv-programs",
  UploadCSVCohorts = "/upload-csv-cohorts",
  UploadCSVRequirementsEPA = "/upload-csv-requirements/epas",
  UploadCSVRequirementsCompetency = "/upload-csv-requirements/competencies",
  UploadCSVRequirementsITER = "/upload-csv-requirements/iters",
  UploadSpreadsheetFramework = "/upload-spreadsheet-framework",
  OrganizationUploadCSVRequirementsEPA = "/organization/:organizationId/upload-csv-requirements/epas",
  OrganizationUploadCSVRequirementsCompetency = "/organization/:organizationId/upload-csv-requirements/competencies",
  OrganizationUploadCSVRequirementsITER = "/organization/:organizationId/upload-csv-requirements/iters",
  OrganizationUploadSpreadsheetFramework = "/organization/:organizationId/upload-spreadsheet-framework",

  Profile = "/profile",

  Chat = "/chat",
  Notifications = "/notifications",
  Posts = "/posts",
  PostCreate = "/posts/new",
  PostDetail = "/posts/:postId",

  FeedbackList = "/feedbacks",
  FeedbackDetail = "/feedback/:feedbackId",
  FeedbackSubmissionConfirmation = "/feedback/submission-confirmation",

  Onboarding = "/organization/:organizationId/onboarding",

  SurveysList = "/surveys",
  SurveyCreate = "/survey/create",
  SurveyEdit = "/survey/:surveyId/edit",
  OrganizationSurveysList = "/organization/:organizationId/surveys",
  OrganizationSurveyCreate = "/organization/:organizationId/survey/create",
  OrganizationSurveyEdit = "/organization/:organizationId/survey/:surveyId/edit",
  SurveyAnswer = "/survey/:surveyId/answer",
  OrganizationSurveyAnswer = "/organization/:organizationId/survey/:surveyId/answer",
  AnswersList = "/survey/:surveyId/answers",
  OrganizationAnswersList = "/organization/:organizationId/survey/:surveyId/answers",
  SurveyAnswers = "/survey/:surveyId/answers/:submissionId",
  OrganizationSurveyAnswers = "/organization/:organizationId/survey/:surveyId/answers/:submissionId",
  AnswerDetail = "/answer/:answerId",
  OrganizationAnswerDetail = "/organization/:organizationId/answer/:answerId",

  CampaignsList = "/campaigns",
  CampaignCreate = "/campaign/create",
  CampaignEdit = "/campaign/:campaignId/edit",
  CampaignAnswer = "/campaign/:campaignId/answer",
  OrganizationCampaignsList = "/organization/:organizationId/campaigns",
  OrganizationCampaignCreate = "/organization/:organizationId/campaign/create",
  OrganizationCampaignEdit = "/organization/:organizationId/campaign/:campaignId/edit",
}

export enum CoachRoutes {
  FeedbackPortal = "/feedback-portal",
  FeedbackDetail = "/feedback-portal/:feedbackId",
  FeedbackGuide = "/feedback-guide",
  Learners = "/learners",
  LearnerDetail = "/learner/:userId",
  RequestFeedback = "/learner/:userId/request-feedback",
  GiveFeedback = "/give-feedback",
  GiveFeedbackForLearner = "/give-feedback/:userId",
}

export enum StudentRoutes {
  RequestFeedback = "/request-feedback",
  RequestFeedbackContinue = "/request-feedback/:feedbackId",
  Requirements = "/requirements",
  RequirementsEPADetails = "/requirements/epa/:requirementId",
  RequirementsCompetencyDetails = "/requirements/competency/:requirementId",
  RequirementsITERDetails = "/requirements/iter/:requirementId",
  FeedbackPortal = "/feedback-portal",
  WellnessDEIB = "/wellness-resources",
  Calendar = "/student-calendar",
  Survey = "/student-surveys",
  MentorList = "/mentors",

  OrganizationOnboardingStudentList = "/organization/:organizationId/onboarding-students",
}
